import { atom } from "jotai";
import { Route } from "../types";

export const drawerOpenAtom = atom(false);
export const activeMenuItemAtom = atom<Route>();
export const setActiveMenuItemFromPathAtom = atom<
  null,
  [path: string, menus: Route[]],
  void
>(null, (get, set, path, menus) => {
  const menu = menus.find((e) => e.path.split("/")[1] === path.split("/")[1]);

  if (menu) {
    set(activeMenuItemAtom, menu);
  }
});
export const contentWidthAtom = atom("100vw");
